import { APP_CONFIG } from '@config/constants'

const SIGNALR_BUNDLE_PATH = '/signalr.min.js'
let signalRLoaderPromise = null

function normalizeBaseUrl(baseUrl) {
  if (!baseUrl || baseUrl === '/') return ''
  return baseUrl.replace(/\/$/, '')
}

function resolveHubUrl() {
  const hubPath = APP_CONFIG.SIGNALR_PRAZOS_HUB_PATH

  if (APP_CONFIG.SIGNALR_URL) {
    return `${normalizeBaseUrl(APP_CONFIG.SIGNALR_URL)}${hubPath}`
  }

  if (APP_CONFIG.API_BASE?.startsWith('http')) {
    return `${normalizeBaseUrl(APP_CONFIG.API_BASE)}${hubPath}`
  }

  return hubPath
}

async function loadSignalRClient() {
  if (globalThis.signalR) return globalThis.signalR

  if (!signalRLoaderPromise) {
    signalRLoaderPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = SIGNALR_BUNDLE_PATH
      script.async = true
      script.onload = () => resolve(globalThis.signalR)
      script.onerror = () => reject(new Error('Não foi possível carregar o cliente SignalR'))
      document.head.appendChild(script)
    })
  }

  return signalRLoaderPromise
}

export async function createPrazoHubConnection(accessTokenFactory) {
  const signalR = await loadSignalRClient()

  if (!signalR?.HubConnectionBuilder) {
    throw new Error('Cliente SignalR indisponível no navegador')
  }

  return new signalR.HubConnectionBuilder()
    .withUrl(resolveHubUrl(), {
      accessTokenFactory,
      withCredentials: true
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000])
    .configureLogging(signalR.LogLevel.Warning)
    .build()
}
